$('.lunch-menu-tabs__slides').on('init', function(event, slick){
    $('.lunch-menu-tabs__slide-hide').removeClass('is-hidden');
});

$('.lunch-menu-tabs__slides').slick({
    adaptiveHeight: true,
    arrows: false,
    draggable: false,
    infinite: false,
});

$('.lunch-menu-tabs__link').click(function (e) {
    e.preventDefault();
    $('.lunch-menu-tabs__slides').slick('slickGoTo', $(this).data('position'));
});

$('.lunch-menu-tabs__slides').on('afterChange', function (event, slick){
    $('.lunch-menu-tabs__tabs li').removeClass('is-active');
    $('.lunch-menu-tabs__tabs li').find("[data-position='" + slick.slickCurrentSlide() + "']").parent().addClass('is-active');
});
